/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import React from 'react'
import r from '../../../util/Renderer'
import { BaseLayout, ListViewLayout, LocalAreaLayout } from 'ui-library/dist/external/layouts'
import {
  DataTable,
  DataTableColumn as TD,
  DataTableHeader as TH,
  DataTableRow as TR,
  Detail,
  List,
  ListRow,
  ListRowItem,
  NavigationDrawer,
  NormalButton,
  ToolbarDateNavigation
} from 'ui-library/dist/external/components'
import LocalDate from '../../../domain/type/Date'
import Date from '../../unit/Date'
import Money from '../../unit/Money'
import Dropdown from '../../atoms/input/Dropdown'
import ClosingStatus from '../../../domain/model/closing/Status'
import { calcStayingDays } from '../../../util/DateProcessing'
import MonthlyReportAction from '../../../action/monthly_report'
import AccommodationTax from '../../../domain/model/tax/AccommodationTax'
import { Link } from 'react-router-dom'
import SummaryAccommodationTax from '../../organisms/tax/SummaryAccommodationTax'

function ListView(props) {
  const date = props.match.params.date
  const monthly_close_date = date ? LocalDate.parse(date) : LocalDate.today().beginningOfMonth()
  const toolbar = { label: `宿泊税一覧`, items: props.accountMenu }
  const reservation = props.reservation
  const accommodation_tax = props.reservation.accommodation_tax

  const paginations = {
    current: {
      label: '今月',
      onClick: e => {
        const current = LocalDate.today()
          .beginningOfMonth()
          .toISODate()
        MonthlyReportAction.onAccommodataTaxMonthChanged(current, props.search.search_hotel_id)
      }
    },
    prev: {
      onClick: e => {
        const prevDate = monthly_close_date.lastMonth().toISODate()
        MonthlyReportAction.onAccommodataTaxMonthChanged(prevDate, props.search.search_hotel_id)
      }
    },
    next: {
      onClick: e => {
        const nextDate = monthly_close_date.nextMonth().toISODate()
        MonthlyReportAction.onAccommodataTaxMonthChanged(nextDate, props.search.search_hotel_id)
      }
    }
  }

  const meta = {
    component: ToolbarDateNavigation,
    data: { label: monthly_close_date.format('yyyy年MM月'), paginations: paginations }
  }

  return (
    <React.Fragment>
      <NavigationDrawer toolbar={toolbar} navigations={props.navigations} meta={meta} />

      <BaseLayout>
        <LocalAreaLayout
          left={
            <React.Fragment>
              <Dropdown
                raised
                name="search_hotel_id"
                value={props.search.search_hotel_id}
                options={props.option_hotels}
                isClearable={false}
                isMulti={false}
                searchable={true}
                onChange={e => MonthlyReportAction.onEditAccommodationTaxSearchCondition(e)}
              />
              <NormalButton onClick={e => MonthlyReportAction.onAccommodationTaxRequestSearch(props.search, date)}>検索</NormalButton>
            </React.Fragment>
          }
        />
        {r.renderIf(!props.search.search_hotel_id)(
          <p style={{ color: '#0c5460', backgroundColor: '#d1ecf1', borderColor: '#bee5eb', padding: '.75rem 1.25rem', marginBottom: '1rem', border: '1px solid transparent', borderRadius: '.25rem' }}>
            宿泊施設を設定してください
          </p>
        )}

        <SummaryAccommodationTax accommodation_tax={props.accommodation_tax} />

        <ListViewLayout>
          <DataTable
            headers={[
              <TH key={1} width="13%">
                チェックアウト日
              </TH>,
              <TH key={2} width="19%">
                部屋名
              </TH>,
              <TH key={3} width="12%">
                宿泊者名
              </TH>,
              <TH key={4} width="10%" isNumber>
                宿泊料金
              </TH>,
              <TH key={5} width="6%" isNumber>
                人数
              </TH>,
              <TH key={6} width="7%" isNumber>
                宿泊数
              </TH>,
              <TH key={7} width="12%" isNumber>
                宿泊税計算額
              </TH>,
              <TH key={8} width="7%" isNumber>
                宿泊税受領額
              </TH>,
              <TH key={9} width="7%" isNumber>
                決済手数料
              </TH>,
              <TH key={10} width="7%" isNumber>
                　入金額
              </TH>
            ]}
            rows={props.accommodation_tax.map(tax => {
              const totalGuest = tax.number_of_guests
              const totalStayingDays = tax.number_of_nights
              const calcAccommodationTaxPerPerson = AccommodationTax.calculateAccomodationTax(tax.price, totalStayingDays, totalGuest)
              const calcAccommodationTax = calcAccommodationTaxPerPerson * totalGuest * totalStayingDays
              const accom_tax = Math.ceil(tax.tax_per_day * (tax.number_of_guests * tax.number_of_nights))

              return (
                <TR key={tax.id} onClick={e => MonthlyReportAction.showAccommodationTaxDetail(date, tax.id)}>
                  <TD>
                    <Date>{tax.check_out}</Date>
                  </TD>
                  <TD>{tax.room_name}</TD>
                  <TD>{tax.reserved_name}</TD>
                  <TD isNumber>
                    <Money>{tax.price}</Money>
                  </TD>
                  <TD isNumber>{totalGuest}人</TD>
                  <TD isNumber>{totalStayingDays}泊</TD>
                  <TD isNumber>
                    <Money>{calcAccommodationTax}</Money>
                    <br />
                    <small>
                      (<Money>{calcAccommodationTaxPerPerson}</Money>/人泊)
                    </small>
                  </TD>
                  <TD isNumber>
                    <ActualAccommodationTax expected={calcAccommodationTax} actual={accom_tax} />
                  </TD>
                  <TD isNumber>
                    <Money>{tax.payment_commission}</Money>
                  </TD>
                  <TD isNumber>
                    <Money>{accom_tax - tax.payment_commission}</Money>
                  </TD>
                </TR>
              )
            })}
          />
        </ListViewLayout>
        {r.renderIf(props.showDetail)(
          <Detail onDeactivate={e => MonthlyReportAction.hideAccommodationTaxDetail(date)}>
            <List>
              <ListRow>
                <ListRowItem
                  width={'400px'}
                  overline={
                    <React.Fragment>
                      {reservation.stay} &nbsp;&nbsp;
                      <Link to={`/reservation/${reservation.id}/detail`} target="_blank">
                        ID: {reservation.id}
                      </Link>
                    </React.Fragment>
                  }
                  primaryText={reservation.name}
                  secondaryText={`${reservation.check_in ? reservation.check_in.toISODate() : null} ~ ${reservation.check_out ? reservation.check_out.toISODate() : null}`}
                />
                <ListRowItem width={'180px'} secondaryText={`宿泊料金: ¥${reservation.price}`} />
                <ListRowItem width={'180px'} secondaryText={`大人: ${reservation.num_adult}人, 子供: ${reservation.num_child}人`} />
                <ListRowItem width={'180px'} secondaryText={`OTA: ${reservation.site_referer}`} />
                <ListRowItem width={'180px'} secondaryText={`OTA手数料: ¥${reservation.commission}`} />
                <ListRowItem width={'180px'} secondaryText={`予約番号: ${reservation.reservation_code}`} />
              </ListRow>
              <ListRowAccommodationTax accommodation_tax={accommodation_tax} />
            </List>
          </Detail>
        )}
      </BaseLayout>
    </React.Fragment>
  )
}

function guestTotal(reservations) {
  const total = reservations.reduce((sum, reservation) => {
    return sum + reservation.num_adult
  }, 0)

  return total
}

function stayingDaysTotal(reservations) {
  const total = reservations.reduce((sum, reservation) => {
    return sum + calcStayingDays(reservation.check_in, reservation.check_out)
  }, 0)

  return total
}

function ListRowAccommodationTax(props) {
  const accommodationTax = props.accommodation_tax
  if (!accommodationTax) {
    return <ListRow />
  }

  const tax_price = Math.ceil(accommodationTax.tax_per_day * (accommodationTax.number_of_guests * accommodationTax.number_of_nights))
  const created_at = new LocalDate(accommodationTax.created_at)
  const updated_at = new LocalDate(accommodationTax.updated_at)
  return (
    <ListRow>
      <ListRowItem width={'180px'} secondaryText={`宿泊税受領額: ¥${tax_price || 0}`} />
      <ListRowItem width={'180px'} secondaryText={`決済手数料: ¥${accommodationTax.payment_commission || 0}`} />
      <ListRowItem width={'180px'} secondaryText={`登録日: ${created_at.toISODate() || ''}`} />
      <ListRowItem width={'180px'} secondaryText={`最終更新日: ${updated_at.toISODate() || ''}`} />
      <ListRowItem width={'360px'} secondaryText={`決済コード: ${accommodationTax.payment_code || ''}`} />
      <ListRowItem width={'360px'} secondaryText={`宿泊税メモ: ${accommodationTax.memo || ''}`} />
    </ListRow>
  )
}

function ActualAccommodationTax(props) {
  if (props.expected == props.actual) {
    return <Money>{props.actual}</Money>
  }

  return (
    <span style={{ color: 'red' }}>
      <Money>{props.actual}</Money>
    </span>
  )
}

function DailyClosingStatus(props) {
  const status = props.children
  const code = ClosingStatus.getCode(status)

  // 暫定対応: ui-libraryに移行する
  const style = {
    fontSize: '0.68rem',
    WebkitFontSmoothing: 'subpixel-antialiased',
    textAlign: 'center',
    width: '48px',
    display: 'inline-block',
    padding: '2px',
    borderRadius: '12px',
    color: '#fff'
  }

  if (code === ClosingStatus.SAVED) {
    style['backgroundColor'] = '#A2A2A2'
  } else if (code === ClosingStatus.CLOSED) {
    style['backgroundColor'] = '#4DB5F0'
  } else {
    style['backgroundColor'] = '#F06464'
  }

  return <small style={style}>{ClosingStatus.getLabel(status)}</small>
}

export default ListView
